import React from 'react';

const Error = () => {
    return (
        <div className='text-center lg:my-40 my-20'>
            <h2 className='text-8xl text-red-600'>404</h2>
            <p className='text-3xl text-red-600'>Page not Found</p>
        </div>
    );
};

export default Error;